import { constants } from '@bedc/constants';

import { Request } from '../../../../api/job/search/Request';

import { SearchDataTableType } from './SearchDataTableType';

export const JobType = SearchDataTableType({
	request: Request,
	columnFields: constants.job.search.columnFields,
	filterIds: constants.job.search.filterIds,
});
